import { Attributes, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ExcessiveScheduleTasksReportCriteria extends ValueObject  
{
    @Attributes.Integer()
    public limit: number = 0;
}